<template>
  <section class="container my30 px15 cl-black flex-full" v-if="typeof currentPartner !== 'undefined'">
    <div class="row">
      <div class="col-xs-12">
        <breadcrumbs class="pt20 pb20 " :with-homepage="true" :active-route="$t('Departments')" />
      </div>
    </div>
    <div class="row center-xs">
      <header class="col-md-12 categories-wrapper">
        <h1 class="align-center cl-accent categories-title">
          {{ $t('Categories of goods in ') + currentPartner.title }}
        </h1>
      </header>
    </div>
    <div class="main row">
      <div class="card col-lg-3 col-md-4 col-sm-6 col-xs-6"
           v-if="categories.length > 0"
           v-for="(category, index) in categories" :key="index">
        <div class="card-wrap">
          <router-link class="no-underline parent-link" :to="categoryLink(category)">
            <div class="row parent mb20">
              <img class="col-xs-12 col-md-4" :src=" imageUrl + category.image" :alt="category.name"/>
              <span class="col-xs-12 col-md-8"> {{ category.name }}</span>
            </div>
            <div class="children mb15 hidden-xs" v-for="(child, childIndex) in category.children_data" :key="childIndex">
              <router-link class="no-underline" :to="categoryLink(child)" v-if="childIndex < 4"> {{ child.name }} </router-link>
            </div>
            <div class="children view-all mb15 hidden-xs" v-if="category.children_data.length > 4">
              <router-link class="no-underline" :to="categoryLink(category)"> Ще > </router-link>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import config from 'config'
  import {mapActions, mapGetters} from 'vuex';
  import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
  import { processURLAddress } from '@vue-storefront/core/helpers'
  import Breadcrumbs from '../components/core/Breadcrumbs.vue'
  import {htmlDecode} from "@vue-storefront/core/filters";

  export default {
    name: 'Departments',
    components: {
      Breadcrumbs
    },
    computed: {
      imageUrl () {
        let url = processURLAddress(config.entities.category.categoriesImageWay);
        let width = '300';
        let height = '/300';
        let action = '/resize/';

        return url + width + height + action;
      },
      ...mapGetters({
        categories: 'products_categories/categories',
        currentPartner: 'partners/getCurrentPartner',
        currentLocation: 'locations/getActiveLocation'
      })
    },
    mounted() {
      this.setCategories({ id: 0, store: this.$route.params.store })
    },
    methods: {
      ...mapActions({
        setCategories: 'products_categories/setCategories'
      }),
      categoryLink (category) {
        return `/${this.currentLocation.code}/${this.currentPartner.code}${formatCategoryLink(category)}`
      }
    },
    metaInfo () {
      let metaDescription = 'Привеземо Вам усе що забажаєте. У нас в каталозі Ви можете переглянути та замовити страви та товари з найкращих закладів харчування, супермаркетів та гіпермаркетів міста'
      if (this.currentPartner.display_mode === 'food') {
        return {
          title: this.currentPartner.about + ' - Доставка з ' + this.currentPartner.title,
          meta: [
            {
              vmid: 'description',
              name: 'description',
              content: metaDescription
            }
          ]
        }
      }

      let list = ''
      let maxCatTitles = this.categories.length >= 3 ? 3 : this.categories.length
      if (maxCatTitles && maxCatTitles > 0) {
        for (let i = 0; i < maxCatTitles; i++) {
          if (i !== 0) {
            list = list + ', '
          }
          list = list + this.categories[i].name
        }
      }

      return {
        title: `${list} та інше з ${this.currentPartner.title}`,
        meta: [
          {
            vmid: 'description',
            name: 'description',
            content: metaDescription
          }
        ]
      }
    }
  }
</script>
<style lang="scss" scoped>
  .container{
    .main{
      padding: 16px 8px;
      @media (max-width: 768px) {
        padding: 8px 0;
      }
      background-color:  rgb(238, 238, 238);;
    }
  }
  .categories-title {
    font-size: 36px;
  }
  .card {
    padding-bottom: 16px;
    color: #333333;

    .card-wrap{
      position: relative;
      background-color: #fff;
      height: 100%;
      border-radius: 4px;
      overflow: hidden;
    }
    .parent:hover{
      cursor: pointer;
    }
    .parent{
      padding-left: 30px;
      padding-right: 30px;
      padding-top: 20px;
      position: relative;
      @media (max-width: 768px) {
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 0;
        margin-bottom: 8px;

      }
    }
    .parent img{
      position: absolute;
      right: 0px;
      top: 0;
      padding: 0;
      @media (max-width: 768px) {
        max-width: 100px!important;
        position: absolute;
        top: -16px;
      }

    }
    a.parent-link span{
      font-weight: 800;
      font-size: 18px;
      color: rgb(66, 66, 66);
      min-height: 48px;
      max-height: 48px;
      overflow-y: hidden;
      @media (max-width: 768px) {
        margin-top: 90px;
      }
    }

    .children a{
      display: inline-block;
      text-overflow: ellipsis;
      overflow-x: hidden;
      white-space: nowrap;
      width: 100%;
    }
    .children{
      font-size: 15px;
      padding-left: 30px;
      padding-right: 30px;
      display: block;
      @media (max-width: 768px) {
        padding-left: 15px;
        padding-right: 15px;
        display: none;
      }


    }
    .children.view-all a{
      color: #f9a200;
      font-weight: bold;
      font-size: 18px;
    }
    .parent-link a{
      color: #000;
    }
  }
  .parent {
    font-weight: bold
  }
  .children a {
    font-weight: 100
  }
  .categories-wrapper {
    margin-top: -30px;
  }
  .cl-accent {
    @media (max-width: 555px) {
      font-size: 32px;
    }
  }
</style>
